export const props = () => [
    {
        key: 'hide',
        label: '是否隐藏',
        type: 'boolean',
    },
    {
        key: 'disabled',
        label: '是否禁用',
        type: 'boolean',
    },
    {
        key: 'type',
        label: '按钮样式',
        type: 'enum',
        collection: [
            {
                label: 'primary',
                value: 'primary',
            },
            {
                label: 'white',
                value: 'white',
            },
            {
                label: 'success',
                value: 'success',
            },
            {
                label: 'danger',
                value: 'danger',
            },
            {
                label: 'dark',
                value: 'dark',
            },
        ],
    },
    {
        key: 'ghost',
        label: '是否为幽灵按钮',
        type: 'boolean',
    },
    {
        key: 'size',
        label: '尺寸',
        type: 'enum',
        collection: [
            {
                label: 'small',
                value: 'small',
            },
            {
                label: 'medium',
                value: 'medium',
            },
            {
                label: 'large',
                value: 'large',
            },
        ],
    },
    {
        key: 'text',
        label: '按钮文字',
        type: 'string',
    },
    {
        key: 'actionType',
        label: '按钮动作',
        type: 'enum',
        collection: [
            {
                label: '提交整个表单数据',
                value: 'submit',
            },
            {
                label: '提交父容器表单数据',
                value: 'submit-container',
            },
            {
                label: '下载',
                value: 'download',
            },
            {
                label: '跳转链接',
                value: 'href',
            },
            {
                label: '打开弹窗',
                value: 'dialog',
            },
            {
                label: '无动作',
                value: 'none',
            },
            {
                label: '自定义事件',
                value: 'custom-event',
            },
        ],
    },
    {
        key: 'link',
        label: '跳转/下载URL',
        type: 'string',
    },
    {
        key: 'iconSrc',
        label: '图标URL',
        type: 'string',
    },
    {
        key: 'dialogUid',
        label: '弹窗id',
        type: 'uuid-select',
    },
    {
        key: 'customEventName',
        label: '自定义事件名',
        type: 'string',
    },
];

export const init = () => ({
    hide: false,
    disabled: false,
    type: 'primary',
    ghost: false,
    size: 'large',
    text: '确认',
    actionType: 'submit',
    link: '',
    iconSrc: '',
    dialogUid: '',
    customEventName: 'custom-event',
});

export const name = '按钮';

export const component = 'mobile-general-form-button';

import { events as baseEvents } from '../component-base/props';
export const events = [
    'click',
    ...baseEvents,
];
